import styled, { css } from 'styled-components';
import { ColorPicker, Form, Input, token } from '@bynder/design-system';

export const PickerContainer = styled.div<{ disableAlpha?: boolean }>`
    position: relative;

    ${(props) =>
        props.disableAlpha &&
        css`
            & > div > div:nth-child(2) > div:nth-child(1) {
                width: 180px;
                margin: 0 0 0 auto;
            }
        `}

    button {
        position: absolute;
        top: 142px;
        left: 16px;
        background-color: ${token.white};
        z-index: 2;

        ${(props) =>
            props.disableAlpha &&
            css`
                top: 133px;
            `}
    }
`;

// todo: ColorPicker is imported here as second overload fn, can't understand how to fix it
export const StyledColorPicker = styled(ColorPicker)`
    & > div {
        width: 270px;
    }
    & > div > div:nth-child(2) {
        grid-template-columns: minmax(10px, 1fr) 85px;
    }
`;

export const StyledRow = styled.div`
    display: grid;
    grid-template-columns: 134px minmax(71px, auto) auto;
    gap: ${token.spacing3};
    align-items: center;
`;

export const StyledInput = styled(Input)`
    width: calc(100% + 3px);
`;
